import { SearchCarHireLocationDetails } from './SearchCarHireLocationDetails'
import { SearchCarHireLocationType } from './SearchCarHireLocationDetails.types'

export { SearchCarHireLocationDetails, SearchCarHireLocationType }
